import { useTheme } from "@mui/material";
import { CalculatorListContent } from "web_myplann/Calculators/Components/CalculatorListContent";
import { CalculatorUnavailableDrawer } from "web_myplann/Calculators/Components/CalculatorUnavailableDrawer";
import { useCalculatorUnavailableDrawer } from "web_myplann/Calculators/Hooks/useCalculatorUnavailableDrawer";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const CalculatorListPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const {
		unavailableType,
		isUnavailableOpen,
		openUnavailable,
		closeUnavailable,
	} = useCalculatorUnavailableDrawer();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<NavigationHeader
					title={t(Resources.Calculators.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			<CalculatorListContent onUnavailableSelect={openUnavailable} />
			<CalculatorUnavailableDrawer
				open={isUnavailableOpen}
				type={unavailableType}
				onClose={closeUnavailable}
			/>
		</MyPlannLayout>
	);
};
